import React from 'react'
import { Card, CardContent, CardHeader, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material'
import { formatNumber, numberPrecision } from '../../../../helpers/UtilityHelper'

const DeliveryAdherenceReport = ({ data = [], reattemptConversionSummary }) => {
    if (!data || data.length === 0 || !reattemptConversionSummary) return null
    if (!reattemptConversionSummary.totalReattemptRequested) return null

    const rows = [
        { label: 'Re-attempt Requested', key: 'totalReattemptRequested' },
        { label: 'Re-attempt Delivered', key: 'reattemptDelivered' },
        { label: 'Re-attempt Happened (Not Delivered)', key: 'actualReattemptHappen' },
        { label: 'Re-attempt Not Happened', key: 'actualReattemptNotHappen' },
        { label: 'Conversion %', key: 'reattemptConversionPercentage', isPercentage: true },
        { label: 'Adherence %', key: 'reattemptAdherence', isPercentage: true },
    ]

    return (
        <Card elevation={1}>
            <CardHeader
                title="Delivery Adherence Report"
                subheader="Breakdown of NDR shipments where reattempt was requested"
            />
            <CardContent>
                <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem', backgroundColor: '#FFF9C4' }}>Metric</TableCell>
                                {data.map(period => (
                                    <TableCell
                                        key={period.name}
                                        align="center"
                                        sx={{ fontWeight: 'bold', fontSize: '0.75rem', backgroundColor: '#FFF9C4' }}
                                    >
                                        {period.name}
                                    </TableCell>
                                ))}
                                <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '0.75rem', backgroundColor: '#E0E0E0' }}>Overall</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map(row => (
                                <TableRow key={row.key}>
                                    <TableCell sx={{ fontSize: '0.75rem', fontWeight: 500 }}>{row.label}</TableCell>
                                    {data.map(period => (
                                        <TableCell key={period.name} align="center" sx={{ fontSize: '0.75rem' }}>
                                            {row.isPercentage
                                                ? `${numberPrecision(period[row.key])}%`
                                                : formatNumber(period[row.key])
                                            }
                                        </TableCell>
                                    ))}
                                    <TableCell align="center" sx={{ fontSize: '0.75rem', fontWeight: 600 }}>
                                        {row.isPercentage
                                            ? `${numberPrecision(reattemptConversionSummary[row.key])}%`
                                            : formatNumber(reattemptConversionSummary[row.key])
                                        }
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    )
}

export default DeliveryAdherenceReport
